import type { ToolTestResult } from '../../lib/api';
import { ToolTestErrorCard } from './ToolTestErrorCard';
import resultStyles from './ToolTestResult.module.css';

interface LookupToolTestResultProps {
  result: ToolTestResult;
}

const lookupResults = (result: Extract<ToolTestResult, { status: 'success' }>): unknown[] => {
  if (!result.data || typeof result.data !== 'object') return [];
  const results = (result.data as { results?: unknown }).results;
  return Array.isArray(results) ? results : [];
};

export const LookupToolTestResult = ({ result }: LookupToolTestResultProps) => {
  if ('error' in result) return <ToolTestErrorCard error={result} />;
  if (result.status === 'upstream_http_error') {
    return (
      <section className={resultStyles.card}>
        <h4 className={resultStyles.errorTitle}>Unexpected HTTP result</h4>
        <p className={resultStyles.errorHint}>Schema lookups do not call a partner HTTP endpoint.</p>
      </section>
    );
  }

  const results = lookupResults(result);
  if (results.length === 0) {
    return (
      <section className={resultStyles.card}>
        <span className={resultStyles.successBadge}>success</span>
        <h4 className={resultStyles.emptyStateTitle}>No matching records</h4>
        <p className={resultStyles.emptyStateHint}>
          The selected contact and fixed filters were valid, but no synced records matched.
        </p>
      </section>
    );
  }

  const countLabel = `${results.length} ${results.length === 1 ? 'record' : 'records'} matched`;
  return (
    <section className={resultStyles.card}>
      <header className={resultStyles.cardHeader}>
        <span className={resultStyles.cardTitle}>Projected records</span>
        <span className={resultStyles.successBadge}>{countLabel}</span>
      </header>
      <pre className={resultStyles.code}>{JSON.stringify(results, null, 2)}</pre>
    </section>
  );
};
